import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './kostenstelle.list-view.html',
    styleUrls: ['./kostenstelle.list-view.scss']
})
export class KostenstelleListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
